import { loadBackgroundTranslations, defaultI18nConfig } from '@sdx/b2o-fe-tools';
import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector, { type DetectorOptions } from 'i18next-browser-languagedetector';
import { resources as staticResources } from './resources';
import { LANGUAGE_STORAGE_KEY } from './languageStorage';

const namespaces = ['common', 'apps', 'header', 'login', 'logout', 'notifications', 'maintenance'];

const i18n = i18next.createInstance();

const setDocumentLanguage = (language?: string): void => {
  if (typeof document !== 'undefined' && language != null && language !== '') {
    document.documentElement.lang = language;
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    ns: namespaces,
    resources: staticResources,
    ...defaultI18nConfig,
    // Keep after the spread, and keep the inner spread: the detector fills only
    // `undefined` keys from its OWN defaults, so dropping either re-breaks #822068.
    detection: {
      ...(defaultI18nConfig.detection as DetectorOptions),
      lookupLocalStorage: LANGUAGE_STORAGE_KEY,
    },
  })
  .then(() => setDocumentLanguage(i18n.resolvedLanguage ?? i18n.language))
  .catch(() => {});

i18n.on('languageChanged', () => setDocumentLanguage(i18n.resolvedLanguage ?? i18n.language));

export const loadTranslationsForLanguage = (translationsFeatureFlag?: boolean): void => {
  const languageApiUrl = import.meta.env.VITE_LANGUAGE_API_URL;

  if (translationsFeatureFlag === true && languageApiUrl) {
    loadBackgroundTranslations(i18n, languageApiUrl, i18n.resolvedLanguage ?? i18n.language);
  }
};

export const initializeI18n = (translationsFeatureFlag?: boolean): void => {
  loadTranslationsForLanguage(translationsFeatureFlag);
};

export default i18n;
